module.exports = __webpack_public_path__ + "70f13ba5ca2070b5f6576b1689b28bec.pdf";